export default __webpack_public_path__ + "static/media/Flag_of_Iraq.8096e279.svg";